import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';
import { Indicator , IndicatorState } from './indicatorTypes';


export const createIndicator = createAsyncThunk(
    'performance/createIndicator',
    async (data: Indicator, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.post('/performance/indicator', data);          
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create Indicator');
      }
    }
  );

  export const fetchAllIndicator = createAsyncThunk(
    'performance/fetchAllIndicator',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/performance/indicator');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Indicator');
        }
    }
);

export const fetchIndicatorById = createAsyncThunk(
    'performance/fetchIndicatorGroupById',
    async (IndicatorId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/performance/indicator/${IndicatorId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch IndicatorGroup');
        }
    }
);

export const deleteIndicator = createAsyncThunk(
    'performance/deleteIndicator',
    async (IndicatorId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.delete(`/performance/indicator/${IndicatorId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete Indicator');
        }
    }
);

export const updateIndicator = createAsyncThunk<any , {IndicatorId: number; data: any}, { rejectValue: string }>(
    'performance/updateIndicator',
    async ({IndicatorId , data}: {IndicatorId : Number; data: Partial<any>}, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.put(`/performance/indicator/${IndicatorId}`, data)
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create Indicator');
      }
    }
  ); 